import { type StopAppointment } from 'core/appointments/domain/Appointment'
import { formatDate } from 'core/utils/date'

import { type Contact, type Facility } from '../../domain/Facility'
import { type Carrier } from '../../domain/Shipment'
import { OpenDockAppointmentDrawer } from '../OpenDockAppointmentDrawer/OpenDockAppointmentDrawer'
import { OpenDockAppointmentScheduledDrawer } from '../OpenDockAppointmentScheduledDrawer/OpenDockAppointmentScheduledDrawer'
import { RegularAppointmentDrawer } from '../RegularAppointmentDrawer/RegularAppointmentDrawer'

type AppointmentDialogsProps = {
  showOpenDockAppointmentDrawer: boolean
  facilityContact?: Partial<Contact>
  shipmentUUID: string
  stopIndex: number
  stopDate: string
  appointment?: StopAppointment
  appointmentDialogIsOpen: boolean
  openDockAppointmentIsOpen: boolean
  facility?: Partial<Facility>
  onClose: () => void
  onConfirm: () => void
  shipmentCarrier: Carrier
}

export function AppointmentDialogs({
  showOpenDockAppointmentDrawer,
  facilityContact,
  shipmentUUID,
  stopIndex,
  stopDate = formatDate(new Date(), 'yyyy-MM-dd'),
  appointment,
  appointmentDialogIsOpen,
  openDockAppointmentIsOpen,
  facility,
  onClose,
  onConfirm,
  shipmentCarrier,
}: AppointmentDialogsProps) {
  const isReschedule = Boolean(appointment?.externalReferenceUuid)

  if (showOpenDockAppointmentDrawer && isReschedule) {
    return (
      <OpenDockAppointmentScheduledDrawer
        isOpen={openDockAppointmentIsOpen}
        onClose={onClose}
        onConfirm={onConfirm}
        appointment={appointment}
        facilityName={facility?.companyName}
        facilityTimezone={facility?.timezone}
        shipmentUUID={shipmentUUID}
        stopIndex={stopIndex}
      />
    )
  }

  if (showOpenDockAppointmentDrawer) {
    return (
      <OpenDockAppointmentDrawer
        isOpen={openDockAppointmentIsOpen}
        onClose={onClose}
        stopDate={stopDate}
        shipmentUUID={shipmentUUID}
        stopIndex={stopIndex}
        shipmentCarrier={shipmentCarrier}
        facilityTimezone={facility?.timezone}
        onConfirm={onConfirm}
      />
    )
  }

  return (
    <RegularAppointmentDrawer
      facilityContact={facilityContact}
      shipmentUUID={shipmentUUID}
      stopIndex={stopIndex}
      stopDate={stopDate}
      appointment={appointment}
      isOpen={appointmentDialogIsOpen}
      onClose={onClose}
      onConfirm={onConfirm}
    />
  )
}
